import { connect } from 'react-redux';

import HeaderUI from './HeaderUI';
import { routingActionCreator } from '../ActionCard/actions/routingActionCreators';
import * as Types from '../ActionCard/actions/actionTypes';


const mapStateToProps = (state) => {

    const { headerContext } = state;

    return { headerContext };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleBack: (alternativeRoute) => {
            dispatch(routingActionCreator(Types.ROUTE_BACK, alternativeRoute));
        },
        handleHome: () => {
            dispatch(routingActionCreator(Types.ROUTE_HOME));
        }
    };
};

const HeaderContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(HeaderUI);

export default HeaderContainer;
